import React from 'react';
import { aboutApproach, aboutChain, images } from '../../data/landing';
import { CtaButton } from '../CtaButton';
export function About() {
  return <section className="w-full bg-canvas px-5 py-16 md:py-24" data-id="element-65" data-mp="ot8efutqav2d">
      <div className="mx-auto max-w-5xl" data-id="element-66" data-mp="12pvjkkvu4rjd">
        <div className="md:grid md:grid-cols-[0.9fr_1.1fr] md:items-start md:gap-12" data-id="element-67" data-mp="12okk2x9fa5y2">
          <div className="md:sticky md:top-8" data-id="element-68" data-mp="yn7cahmrrsoi">
            <img src={images.doctor} alt="Dr. Nathan Brooks in his dental clinic" className="w-full rounded-3xl object-cover" loading="lazy" data-id="element-69" data-mp="az7jlc5wds7a" />
            <p className="mt-4 text-center font-serif text-2xl font-bold text-navy" data-id="element-70" data-mp="jt2t0we1y4sq">Dr. Nathan Brooks</p>
            <p className="text-center text-sm text-muted" data-id="element-71" data-mp="f09mq42xqoej">Creator of Ortho Treatment Map™</p>
          </div>

          <div className="mt-10 md:mt-0" data-id="element-72" data-mp="3nftc2s0hjmob">
            <p className="text-sm font-extrabold uppercase tracking-wider text-sky" data-id="element-73" data-mp="3jfix4puptlxb">About Dr. Nathan Brooks</p>
            <h2 className="mt-2 font-serif text-[32px] font-black leading-tight text-navy md:text-4xl" data-id="element-74" data-mp="339i4nrsxw06k">
              Why I created Ortho Treatment Map™
            </h2>
            <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-muted" data-id="element-75" data-mp="3868j6ap3inpv">
              <p data-id="element-76" data-mp="3cztm8h5jq7vx">
                For years, I’ve watched dentists and orthodontic professionals struggle with something that isn’t talked about enough.
                They don’t necessarily lack knowledge. They’ve studied orthodontics, attended courses, learned techniques and
                understand individual concepts.
              </p>
              <p data-id="element-77" data-mp="2u8tq8vzmvxt5">
                <strong className="text-navy" data-id="element-78" data-mp="2u8ai26zscnsb">But then a real patient sits in front of them…</strong> and suddenly they have to connect
                everything at once:
              </p>
            </div>
            <ul className="mt-4 flex flex-wrap gap-2" data-id="element-79" data-mp="9h9rn7zeapxy">
              {aboutChain.map(c => <li key={c} className="rounded-full bg-white px-3.5 py-1.5 text-sm font-bold text-navy ring-1 ring-navy/15" data-id="element-80" data-mp="egcxgun7906z">
                  {c}
                </li>)}
            </ul>
            <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-muted" data-id="element-81" data-mp="25kehij6uwy5v">
              <p data-id="element-82" data-mp="2jlqwaraa6tq6">
                That’s a very different skill from simply knowing the information. And I experienced the same problem in my own clinical
                development.
              </p>
              <p data-id="element-83" data-mp="1rt9pa25tj85k">
                Over time, I realized that one of the most useful things I could do wasn’t create another massive collection of theory.
                It was to create a <strong className="text-navy" data-id="element-84" data-mp="20md002p2x6wi">repeatable way to organize the decisions.</strong> I designed it around
                the way I want to approach a case:
              </p>
            </div>
            <ol className="mt-5 space-y-2" data-id="element-85" data-mp="18626zt9k1im7">
              {aboutApproach.map((step, i) => <li key={step} className="flex items-center gap-3 font-semibold text-navy" data-id="element-86" data-mp="144gnvq6fg83k" data-mpi={i}>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-navy text-sm text-white" data-id="element-87" data-mp="142nq70dsky7p">{i + 1}</span>
                  {step}
                </li>)}
            </ol>
            <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-muted" data-id="element-88" data-mp="k2m7k6nf6ct3">
              <p data-id="element-89" data-mp="p1go11xwzpa1">
                This isn’t intended to replace clinical training, professional judgment, or patient-specific diagnosis. It’s a planning
                framework — a way to make the thinking behind a case more visible.
              </p>
              <p data-id="element-90" data-mp="1hot7h38s3gz4">
                And most importantly… <strong className="text-navy" data-id="element-91" data-mp="12svj4753jgxg">a way to stop starting from a blank page every time a new case walks through the door.</strong>
              </p>
              <p className="font-serif text-xl font-bold italic text-navy" data-id="element-92" data-mp="17qndd7t7rf4t">— Dr. Nathan Brooks</p>
            </div>
          </div>
        </div>

        <div className="mt-12" data-id="element-93" data-mp="3si5xowssnf3x">
          <CtaButton label="I want the system Dr. Brooks created" data-id="element-94" data-mp="3sifkkbijl65e" />
        </div>
      </div>
    </section>;
}